import React from "react";
import { FormWidgetData } from "./subscribe-form-widget.data";
import "./subscribe-form-widget.styles.scss";

//RP Task 62 - Subscribe form
const SubscribeFormWidget = ({item}) => (
  <div className="outer-widget-container">    
      <div className="form-widget-container">
         <p class="title" dangerouslySetInnerHTML={{ __html: item.SideTitle1 }}></p>      
         <p class="content" dangerouslySetInnerHTML={{ __html: item.SideContent1 }}></p>              
      </div>
      <div className="form-widget-container">
         <p class="title" dangerouslySetInnerHTML={{ __html: item.SideTitle2 }}></p>      
         <p class="content" dangerouslySetInnerHTML={{ __html: item.SideContent2 }}></p>              
      </div>
  </div>
);

export default SubscribeFormWidget;
